import React from "react";
import FormItem from "antd/lib/form/FormItem";
import { Form, Input } from "antd";
import {
  InputWrapper,
  EmailWrapper
} from "../../Step1Setup/styles";
import {
  EmailTitleWrapperFont,
  PercentageTitle
} from "../styles";
import { MarginSpecific } from "./styles";
import { InputField } from "../../../../../CommonComponents/commonStyles";
class InputComponent extends React.Component {
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <FormItem
        colon={false}
        label={
          (this.props.showTitle === false) ? '': (
          this.props.title === "Percentage" ? (
            <PercentageTitle>{this.props.title}</PercentageTitle>
          ) : (
            <MarginSpecific paddingTop="2px">
              <EmailWrapper>
                <EmailTitleWrapperFont>
                  {this.props.title}
                </EmailTitleWrapperFont>
              </EmailWrapper>
            </MarginSpecific>
          ))
        }
      >
        {getFieldDecorator(`input ${this.props.id}`, {
          rules: [
            {
              type: "string"
            }
          ]
        })(
          <InputWrapper>
            <InputField
              id={this.props.id}
              aria-label={this.props.arialabel}
              name={this.props.name}
              maxLength={this.props.max}
              title={this.props.hoverTitle}
              onChange={this.props.handleInputChange}
              onBlur={this.props.handleBlur}
              placeholder={this.props.placeholder}
              value={this.props.value}
            />
          </InputWrapper>
        )}
      </FormItem>
    );
  }
}

const WrappedInputComponent = Form.create({ name: "input" })(InputComponent);

export default WrappedInputComponent;